import { Directive, TemplateRef, Input } from '@angular/core';
import {
  SgAutoCompleteSelectComponent,
  SgAutoCompleteSelectOptionTemplateContext,
  SgAutoCompleteSelectTriggerTemplateContext,
} from '../auto-complete-select/auto-complete-select.component';

@Directive({
  selector: '[sgAutoCompleteSelectOption]',
  standalone: false,
})
export class SgAutoCompleteSelectOptionDirective<T = any> {
  constructor(tRef: TemplateRef<SgAutoCompleteSelectOptionTemplateContext>, cmp: SgAutoCompleteSelectComponent<T>) {
    cmp.optionTpl = tRef;
  }
}

@Directive({
  selector: '[sgAutoCompleteSelectTrigger]',
  standalone: false,
})
export class SgAutoCompleteSelectTriggerDirective<T = any> {
  constructor(tRef: TemplateRef<SgAutoCompleteSelectTriggerTemplateContext>, cmp: SgAutoCompleteSelectComponent<T>) {
    cmp.selectTriggerTpl = tRef;
  }
}

@Directive({
  selector: '[sgAutoCompleteAsyncTemplate]',
  standalone: false,
})
export class SgAutoCompleteAsyncTemplateDirective<T = any> {
  constructor(tRef: TemplateRef<any>, cmp: SgAutoCompleteSelectComponent<T>) {
    cmp.asyncTemplate = tRef;
  }
}
